import script from "./MainForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MainForm.vue?vue&type=script&setup=true&lang=js"

import "./MainForm.vue?vue&type=style&index=0&id=05603d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05603d30"]])

export default __exports__